<script lang="ts">
    import {serverConfig} from "./data.ts";
</script>

{#if $serverConfig.noNewRegistrations}
    <article class="alert alert-warning" style="font-size: 1.5rem; font-weight: bold; color: #d81b60; border: 2px solid #d81b60;">
        Registration Full - Not accepting any new registrations.
    </article>
{:else if $serverConfig.waitlistOnly}
    <article class="alert alert-warning" style="font-size: 1.5rem; font-weight: bold; color: #d81b60; border: 2px solid #d81b60;">
        Registration Full - Accepting Waitlist Registrations Only
    </article>
{/if}